<template>
    <v-container>
        <v-snackbar
            v-model="snackbar"
            :multi-line="true"
            v-if="tx"
            >
            {{ tx }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                    >
                    Fechar
                </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>

    import { EventBus } from "@/event-bus";

    export default {

        name: 'Toast',

        data() {
            return {
                snackbar: false,
                tx: ""
            };
        },

        created()
        {
            this.startToast();
        },

        methods: {

            startToast() {
                EventBus.$on("toast", this.setToast);
            },

            setToast(data) {
                this.snackbar = true;
                this.tx = data.tx;
            }
        }
    }
</script>
